import React from 'react'
import block from 'bem-cn'

import EmptyTableIcon from 'shared/img/empty-table.webp'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import './EmptyFilterResult.scss'

const b = block('empty-filter-result')

export const EmptyFilterResult: React.FC = () => {
  const { tPrefix } = useAppTranslation('common')

  return (
    <div className={b()}>
      <img src={EmptyTableIcon} alt="icon" className={b('icon')} />

      <div className={b('title')}>{tPrefix('table.empty.title')}</div>
    </div>
  )
}
